// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.ov-summ-card[data-v-85b140de] {\n  /* border: 2px solid red; */\n  width: -moz-fit-content;\n  width: fit-content;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n@media screen and (max-width: 890px) {\n.ov-summ-card[data-v-85b140de] {\n    width: 45%;\n}\n}\n@media screen and (max-width: 750px) {\n.ov-summ-card[data-v-85b140de] {\n    width: 100%;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
